// @flow
import axios from 'lib/defaultClient';

export const like = (eventId: string) => axios.post(`/events/${eventId}/like`);

export const unlike = (eventId: string) => axios.delete(`/events/${eventId}/like`);

export const getLikesCount = (eventId: string) => axios.get(`/events/${eventId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/events/like.js